import { render } from "./DesignInput.vue?vue&type=template&id=04a20289&scoped=true"
import script from "./DesignInput.vue?vue&type=script&lang=js"
export * from "./DesignInput.vue?vue&type=script&lang=js"

import "./DesignInput.vue?vue&type=style&index=0&id=04a20289&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a20289"]])

export default __exports__